<template>
  <v-dialog
    v-model="modal"
    max-width="500px"
    persistent>
    <v-card>
      <validation-observer
        ref="form"
        @submit.prevent="onConfirm()">
        <v-card-title>
          <span class="headline">
            <span class="text-error">VOID</span> | {{ orderDetail.orderId }}
          </span>
        </v-card-title>
        <v-card-text>
          <!-- <v-container> -->
          <v-col
            v-if="canVoidOrder"
            cols="12">
            <span class="subtitle-1"> เลือกเหตุผลในการ VOID </span>
            <gw-select
              v-model="voidReason"
              :items="option"
              label="เหตุผล / Reason"
              item-text="text"
              item-value="value"
              :rules="{ required: true }"
              :readonly="readonly" />
          </v-col>
          <v-col v-else>
            <div class="subtitle-1">
              คุณไม่มีสิทธิ <span class="text-error">VOID ORDER</span> นี้ สาขาที่คุณมีสิทธิ
            </div>
            <ul>
              <li
                v-for="(branch, index) of userBranch"
                :key="`user-branch-${index + 1}`">
                {{ branch.name }}
              </li>
            </ul>
            <div class="subtitle-1">
              สาขาของ ORDER
            </div>
            <ul>
              <li
                v-for="(warehouse, index) of warehouseInOrder"
                :key="`order-branch-${index + 1}`">
                {{ warehouse.name }}
              </li>
            </ul>
          </v-col>
          <!-- </v-container> -->
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="readonly"
            color="blue darken-1"
            text
            @click="onCancel()">
            Close
          </v-btn>
          <template v-else>
            <v-btn
              color="red darken-1"
              text
              @click="onCancel()">
              ปิดหน้าต่าง
            </v-btn>
            <v-btn
              v-if="canVoidOrder"
              color="blue darken-1"
              text
              @click="onConfirm()">
              ยืนยัน
            </v-btn>
          </template>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { getRole } from '@/assets/js/Authentication'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      voidReason: ''
    }
  },
  computed: {
    ...mapGetters({
      orderDetail: 'Order/orderDetail',
      getUserBranch: 'Store/userBranch'
    }),
    option () {
      const channel = this.orderDetail?.channel
      const reasonVoid = [
        {
          value: 'DUPLICATE',
          text: 'บิลซ้ำ / Duplicate'
        },
        {
          value: 'WRONG-VRT-DOC',
          text: 'กรอกข้อมูล Vat Refund ผิด'
        },
        {
          value: 'WRONG-TAX-DOC',
          text: 'กรอกข้อมูล E-Tax ผิด'
        },
        {
          value: 'WRONG-TEL',
          text: 'กรอกเบอร์ลูกค้าผิด'
        },
        {
          value: 'WRONG-ITEM',
          text: 'เลืิอกสินค้าผิด'
        },
        {
          value: 'WRONG-BRAN',
          text: 'เลืิอกสาขาผิด'
        },
        {
          value: 'CHANGE-CUS',
          text: 'ลูกค้าเปลี่ยนใจ'
        },
        {
          value: 'REFUND',
          text: 'คืินเงินกรณีอื่น / Other - Refund'
        }
      ]

      const reasonStoreCredit = [
        {
          value: 'STORE-CRE',
          text: 'ให้ Store Credit (Store Credit)'
        }
      ]

      if (['tiktok', 'lazada'].includes(channel)) {
        return reasonVoid
      }
      const allowedStoreCreditRoles = ['online_admin', 'developer', 'management', 'accounting', 'accounting_manager']
      const role = getRole()
      const canSelectStoreCredit = allowedStoreCreditRoles.includes(role)

      return canSelectStoreCredit ? [...reasonVoid, ...reasonStoreCredit] : reasonVoid
    },
    userBranch () {
      return this.getUserBranch.filter((b) => b.id !== 0)
    },
    warehouseInOrder () {
      const warehouses = []
      const subOrders = this.orderDetail?.subOrders || []
      subOrders.forEach((subOrder) => {
        warehouses.push(subOrder.warehouse)
      })
      return warehouses
    },
    canVoidOrder () {
      const role = getRole()
      const storeRoles = [
        'store_manager',
        'acting_assist_store_manager',
        'assist_store_manager',
        'sales_staff'
      ]
      if (!storeRoles.includes(role)) {
        return true
      }

      // check warehouse and order channel if user role in storeRoles
      if (
        this.orderDetail.channel === 'pos'
        && (this.warehouseInOrder.map((wo) => wo.id).filter((element) => this.userBranch.map((ub) => ub.id).includes(element)).length > 0)
      ) {
        return true
      }

      return false
    },
    modal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    async onConfirm () {
      const isValid = await this.$refs.form.validate()

      if (!isValid) {
        return
      }

      this.modal = false
      this.$emit('confirm', this.voidReason)
    },
    onCancel () {
      this.modal = false
    }
  }
}
</script>
